<h3 mat-dialog-title class="title-layout" style="color: red;">Resolve Deleted Model Variant Error </h3>

<div mat-dialog-content>
  
<p>Model {{ numberNoun }} {{ oldModelVariants.join(', ') }} {{ numberVerb }} been deleted and should no longer be used to define pitch variant {{oldVariant.variant_name}}.</p>
  <p><b>Options:</b></p>
  <ol style="margin-left: -12px; margin-top: -8px;">
    <li>Remove variant {{ oldVariant.variant_name }} from the pitch.</li> 
    <li>Use the proposed new pitch variant below. It is the old pitch variant minus the deleted model {{ numberNoun }}.</li>
    <li>Change the proposed new pitch variant by selecting other model variants from the drop down.</li>
  </ol>
  <br>

<form [formGroup]="fg_VariantConfig" >
   <mat-form-field class="card-dialog">
    <mat-label>New Pitch Variant</mat-label>
        <mat-select id="type" matInput cdkTextareaAutosize
          formControlName="f_ModelVariants" [compareWith]="compareObjects" multiple>
          <mat-select-trigger>
              <span *ngIf="selectedModelsList.length > 0">
                  {{ selectedModelsList.join('/') }}
              </span>
          </mat-select-trigger>
          
          <mat-option *ngFor="let model of modelVariantList" [value]="model">
            {{model.model_name}}
          </mat-option>
        </mat-select>
    </mat-form-field>
      <div *ngIf="fg_VariantConfig.get('f_ModelVariants').invalid && 
          fg_VariantConfig.get('f_ModelVariants').errors && 
          (fg_VariantConfig.get('f_ModelVariants').dirty || fg_VariantConfig.get('f_ModelVariants').touched)">
        <small class="error" *ngIf="fg_VariantConfig.get('f_ModelVariants').hasError('required')">
          At least one Model Variant must be selected..
        </small>
      </div>

      </form>

      <span *ngIf = "selectedModelVariants.length > 0">
        All work currently assigned to pitch variant, {{ oldVariant.variant_name }} will be transferred to the new pitch variant {{ selectedModelsList.join('/') }}.
      </span>

      <span *ngIf = "selectedModelVariants.length == 0" style="color: red;">
        <span style="font-weight:500;">Warning!</span> No new variant will be added. On <span style="font-weight: 500;">Submit</span>, pitch variant {{ oldVariant.variant_name }} will be removed from the pitch.
      </span>
</div>

<div mat-dialog-actions>
    <button mat-button color="primary" (click)="onSubmit('create')">Submit</button>
    <button mat-button (click)="onNoClick()">Cancel</button>
</div>

<div *ngIf="isBusy">
    <mat-spinner></mat-spinner>
</div>
